export const environment = {
  production: true,
  APIEndPoint: "https://api.crmcondor.com",
  appName: "CRM Condor",
};
